import { BaseDocument } from "../firestore";

export type MergedStats = {
  [CallStatsEvents.ANSWER]: number;
  [CallStatsEvents.NOANSWER]: number;
};
export type MergedDateStats = Record<string, MergedStats>;

export enum CallStatsEvents {
  ANSWER = "ANSWER",
  BUSY = "BUSY",
  NOANSWER = "NOANSWER",
  CANCEL = "CANCEL",
  IVR_HANGUP = "IVR_HANGUP",
  CONGESTION = "CONGESTION"
}

export type CallStatsReduced = {
  [key in CallStatsEvents]: number;
};

export type CallStats = {
  statsTotal: CallStatsReduced;
  totalCalls: number;
  statsForChosenPeriod: MergedStats;
  totalCallsForChosenPeriod: number;
  byDate: Record<string, CallStatsReduced>;
};

export type MemberCallStats = {
  [email: string]: CallStats;
};

export const DEFAULT_CALL_STATS: CallStats = {
  statsTotal: {} as CallStatsReduced,
  totalCalls: 0,
  statsForChosenPeriod: {} as MergedStats,
  totalCallsForChosenPeriod: 0,
  byDate: {}
};
